import { cva as t } from "class-variance-authority";
const r = t(
  "",
  {
    variants: {
      variant: {
        success: "bg-success",
        info: "bg-primary",
        warning: "bg-warning",
        error: "bg-danger",
        title: "text-white text-start font-regular text-sm ar:font-plex-arabic en:font-inter ar:text-right",
        toast: "w-full flex items-center gap-2 p-3 rounded-lg shadow-lg",
        icon: "items-baseline grow-1 w-5 h-5 m-0 self-baseline font-regular",
        description: "text-white text-start text-xs ar:font-plex-arabic en:font-inter ar:text-right",
        closeButton: "text-neutral-70 hover:text-neutral-80 bg-white shadow transition-colors duration-200 ease-in-out",
        actionButton: "text-white my-auto text-sm en:ml-auto ar:mr-auto  px-2 py-1 border border-solid border-white font-regular text-sm rounded-md hover:border-transparent transition-colors duration-200 ease-in-out ar-text:font-plex-arabic en-text:font-inter"
      }
    }
  }
);
export {
  r as ToastVariants
};
//# sourceMappingURL=ToastVariants.mjs.map
